import merge from 'lodash/merge';
import includes from 'lodash/includes';

import { STYLE_FILL, STYLE_NEUTRAL } from '@eventbrite/eds-button';
import { AU_LOCALE } from '@eventbrite/intl';
import { gettext } from '@eventbrite/i18n';
import { getIsUserInSubscriptionSupportedTld } from '@eventbrite/pricing-and-packaging-ui';

import {
    LOCALE_WITH_VERSION_2,
    PACKAGE_ONE,
    PACKAGE_ONE_VERSION_1,
} from '../../constants/main';
import { canUpdateEssentialsV2 } from '../utils';
import * as features from '../../constants/features';
import {
    CHANGE_PACKAGE,
    TICKET_TYPE,
    FREE_OPTION,
    PACKAGE_DIFFER,
    PAY_FEES,
    PRIVATE_EVENT,
} from '../../constants/faqs';

const OVERRIDE_USER_SETTINGS_VERSION_2 = {
    [PACKAGE_ONE_VERSION_1]: {
        packagesList: {
            CTAs: [
                gettext('Update'),
                gettext('Upgrade'),
                gettext('Contact Us'),
            ],
            CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        },
        grid: {
            CTAs: [
                gettext('Update'),
                gettext('Upgrade'),
                gettext('Contact Us'),
            ],
            CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        },
    },
};

const OVERRIDE_PACKAGE_LIST_PACKAGES_ESSENTIALS_VERSION_2 = {
    [AU_LOCALE]: {
        packagesList: {
            packages: {
                [PACKAGE_ONE]: {
                    features: [
                        ...features.PACKAGE_ONE_FEATURES_AU_V2,
                        features.TICKET_FEES_PAYMENT_PROCESSING,
                    ],
                },
            },
        },
    },
};

/**
 * Generate additional settings to override the features list and the CTA texts/styles
 * on the essentials package on Australia.
 */
export const generateAdditionalSettings = ({
    locale,
    isAuthenticated,
    assortmentsAvailability = {},
}) => {
    let userSettings = {};
    let overrideSettings = {};
    let faqSettings = {};

    const isTldAllowedForNewPricingPage = getIsUserInSubscriptionSupportedTld();

    if (isTldAllowedForNewPricingPage) {
        faqSettings = {
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    TICKET_TYPE,
                    FREE_OPTION,
                    PACKAGE_DIFFER,
                    PAY_FEES,
                    PRIVATE_EVENT,
                ],
            },
        };
    }

    if (includes(LOCALE_WITH_VERSION_2, locale)) {
        if (
            isAuthenticated &&
            canUpdateEssentialsV2({ locale, assortmentsAvailability })
        ) {
            userSettings =
                OVERRIDE_USER_SETTINGS_VERSION_2[PACKAGE_ONE_VERSION_1];
        }

        overrideSettings =
            OVERRIDE_PACKAGE_LIST_PACKAGES_ESSENTIALS_VERSION_2[locale];
    }

    return merge(overrideSettings, userSettings, faqSettings);
};
